import { useEffect, useRef, useState } from "react";
import { C, font } from "../tokens";
import DemoStepsForm from "./DemoStepsForm";

// Modal de exit-intent / fim de página com o MESMO formulário multi-etapas da
// página /agendar-demo (via DemoStepsForm → mesmo webhook do CRM).
export default function DemoModal() {
  const [open, setOpen] = useState(false);
  const shownOnce = useRef(false);
  const engaged = useRef(false);

  const openModal = () => {
    if (shownOnce.current) return;
    shownOnce.current = true;
    setOpen(true);
    try { document.body.style.overflow = "hidden"; } catch {}
  };
  const closeModal = () => {
    setOpen(false);
    try { document.body.style.overflow = ""; } catch {}
  };

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 600) engaged.current = true;
      if (
        engaged.current &&
        window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - 140
      )
        openModal();
    };
    const onMouseOut = (e) => {
      if (engaged.current && !e.relatedTarget && e.clientY <= 0) openModal();
    };
    const onVis = () => {
      if (engaged.current && document.hidden) openModal();
    };
    const onKey = (e) => {
      if (e.key === "Escape") closeModal();
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    document.addEventListener("mouseout", onMouseOut);
    document.addEventListener("visibilitychange", onVis);
    window.addEventListener("keydown", onKey);
    return () => {
      window.removeEventListener("scroll", onScroll);
      document.removeEventListener("mouseout", onMouseOut);
      document.removeEventListener("visibilitychange", onVis);
      window.removeEventListener("keydown", onKey);
    };
  }, []);

  if (!open) return null;

  return (
    <div
      onClick={closeModal}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 300,
        background: "rgba(8,16,42,0.72)",
        backdropFilter: "blur(4px)",
        WebkitBackdropFilter: "blur(4px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
        animation: "slide-up-fade 0.25s ease both",
      }}
    >
      <div
        className="demo-modal-card"
        onClick={(e) => e.stopPropagation()}
        style={{
          position: "relative",
          display: "flex",
          width: "100%",
          maxWidth: 920,
          maxHeight: "94vh",
          overflow: "hidden",
          background: C.surface,
          borderRadius: 22,
          boxShadow: "0 40px 90px rgba(8,16,42,0.5)",
          animation: "slide-down-fade 0.3s cubic-bezier(.16,1,.3,1) both",
        }}
      >
        {/* Fechar */}
        <button
          onClick={closeModal}
          aria-label="Fechar"
          style={{
            position: "absolute",
            top: 14,
            right: 14,
            zIndex: 3,
            width: 34,
            height: 34,
            borderRadius: "50%",
            border: "none",
            cursor: "pointer",
            background: "rgba(10,15,30,0.06)",
            color: C.text,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(10,15,30,0.12)")}
          onMouseLeave={(e) => (e.currentTarget.style.background = "rgba(10,15,30,0.06)")}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
            <path d="M18 6 6 18M6 6l12 12" />
          </svg>
        </button>

        {/* Painel promocional (esquerda) */}
        <aside
          className="demo-modal-aside"
          style={{
            flex: "1 1 42%",
            background: "linear-gradient(150deg, #0560FF 0%, #0A47D8 55%, #204493 100%)",
            color: "#fff",
            padding: "44px 36px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <span
            aria-hidden="true"
            style={{
              position: "absolute",
              top: -60,
              right: -60,
              width: 240,
              height: 240,
              borderRadius: "50%",
              background: "radial-gradient(circle, rgba(255,255,255,0.16), transparent 68%)",
            }}
          />
          <div style={{ position: "relative" }}>
            <h2
              style={{
                fontFamily: font,
                fontSize: 28,
                fontWeight: 800,
                lineHeight: 1.12,
                letterSpacing: -0.8,
                margin: "0 0 16px",
              }}
            >
              Veja sua operação vender mais em uma única tela
            </h2>
            <p
              style={{
                fontFamily: font,
                fontSize: 15,
                lineHeight: 1.6,
                color: "rgba(255,255,255,0.85)",
                margin: "0 0 24px",
              }}
            >
              Agende uma demonstração do IMOBMEET e veja como incorporadoras e
              loteadoras gerenciam vendas, financeiro e recebíveis em um só lugar.
            </p>
            {["CRM + ERP financeiro integrados", "Do lead ao contrato assinado", "Implantação com acompanhamento"].map((t) => (
              <div key={t} style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12, fontFamily: font, fontSize: 14.5, fontWeight: 600 }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#5CF2C0" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
                  <path d="M20 6 9 17l-5-5" />
                </svg>
                {t}
              </div>
            ))}
          </div>
        </aside>

        {/* Formulário (direita) — mesmo formulário multi-etapas de /agendar-demo */}
        <div
          style={{
            flex: "1 1 58%",
            padding: "38px 34px 30px",
            overflowY: "auto",
          }}
        >
          <h3 style={{ fontFamily: font, fontSize: 20, fontWeight: 800, color: C.text, margin: "0 0 4px", letterSpacing: -0.4 }}>
            Agende sua demonstração
          </h3>
          <p style={{ fontFamily: font, fontSize: 13.5, color: C.muted, margin: "0 0 22px" }}>
            Preencha e nossa equipe entra em contato.
          </p>
          <DemoStepsForm onClose={closeModal} origem="popup-exit-intent" />
        </div>
      </div>
    </div>
  );
}
